import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const etudiantAbsences = {
  state: {
    etudiantAbsences: [],
    etudiantAbsence: null
  },
  mutations: {
    setEtudiantAbsences(state, absences) {
      state.etudiantAbsences = absences;
    },
    setEtudiantAbsence(state, absence) {
      state.etudiantAbsence = absence;
    }
  },
  actions: {
    fetchAbsencesByStudent(context, idStudent) {
      return ApiService.getRequest(`/etudiant_absences?etudiant=${idStudent}`).then(
        response => {
          this.commit('setEtudiantAbsences', response.data['hydra:member']);
          return response.data['hydra:member'];
        })
        .catch(error => { console.error(error) });
    },
    fetchAbsenceByProperties(context, data){
      const uri = `/etudiant_absence_retard/${data.etudiantId}/${data.dt_start}/${data.hr_start}`;

      return ApiService.getRequest(uri).then(
        response => {
          context.commit('setEtudiantAbsences', response.data);
        }
      ).catch(error => console.error(error))
    },
    //  paramètres obligatoires : etudiantId (Number) / dt_start (format: YYYY-MM-DD) / dt_end (format: YYYY-MM-DD) / hr_start (format: HH:mm:ss) / hr_end (format: HH:mm:ss)
    fetchAbsenceByStudentAndDates(context, data) {
      let properties = ['etudiantId', 'dt_start', 'dt_end', 'hr_start', 'hr_end'];
      let isValid = false;
      if (data && properties.every(propName => data[propName] !== null && data[propName] !== undefined)) {
        isValid = true;
      }

      if (isValid === true) {
        let uri = '/etudiant_absences?';
        uri += `etudiant.id=${data.etudiantId}`;
        uri += `&dt_start=${data.dt_start}`;
        uri += `&dt_end=${data.dt_end}`;
        uri += `&hr_start=${data.hr_start}`;
        uri += `&hr_end=${data.hr_end}`;
        return ApiService.getRequest(uri)
          .then(
            response => {
              this.commit('setEtudiantAbsence', response.data['hydra:member'][0]);
              return response.data['hydra:member'][0];
            })
          .catch(error => { console.error(error) });
      } else {
        //  paramètres obligatoires : etudiantId (Number) / dt_start (format: YYYY-MM-DD) / dt_end (format: YYYY-MM-DD) / hr_start (format: HH:mm:ss) / hr_end (format: HH:mm:ss)
        throw new Error('Invalid parameters.');
      }

    },
    //  ajout d'une absence à un stagiaire
    async addEtudiantAbsence({ state, dispatch }, data) {
      try {
        const response = await ApiService.postRequest('/etudiant_add_absence', data);
        if (response.data) {
          //Réupere le pointage par l' id absence, puis par l'id etudiant + id emargement
          const pointageAbsence = await dispatch('fetchPointagesByAbsenceId', response.data.id);

          if(pointageAbsence.length === 0){
            let dataPointage = {
              etudiant: data.etudiant,
              emargement: data.emargement
            }
            const pointagePresence = await dispatch("fetchPointageByEtudiantEmargement", dataPointage);

            if(pointagePresence.length === 0){
              let formData = new FormData();
              formData.append('etudiant', data.etudiant);
              formData.append('raison', data.raison);
              formData.append('dt_start', data.dt_start);
              formData.append('dt_end', data.dt_end);
              formData.append('hr_start', data.hr_start);
              formData.append('hr_end', data.hr_end);
              formData.append('etudiant_id', data.etudiant_id);
              formData.append('absence_id', response.data.id);
              formData.append('antenne_id', data.antenne);
              formData.append("emargement", data.emargement);

              let dataAbsence = {
                form: formData,
                etudiant_id: data.etudiant_id,
                emargement: data.emargement
              }
              dispatch('addEtudiantPointageAbsence', dataAbsence);
            }
            else {
              let dataPointage = {
                dt_start: data.dt_start,
                dt_end: data.dt_end,
                hr_start: data.hr_start,
                hr_end: data.hr_end,
                raison: data.raison,
                etudiant: data.etudiant,
                absence_id: response.data.id,
                pointage_id: pointagePresence[0].id,
                emargement: data.emargement,
                typepointage: "absence"
              }
              await dispatch('updatePointageAbsence', dataPointage);
            }
          }
          Notify.create({
            message: "L'absence a été créée avec succès.",
            color: "green"
          });
          return Promise.resolve();
        }
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },
    // Ajoute l'abscence d'un stagiaire
    async addAbsence(context, formData){
      try{
        const response = await ApiService.postRequest('etudiant_absences', formData);
        context.commit('setEtudiantAbsence', response.data);

        Notify.create({
          message: "Abscence ajoutée avec succès",
          color: "green"
        })
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout de l'absence",
          color: 'red'
        })
      }
    },
    //Modifie l'absence séléctionnée
    async updateAbsence({ commit, dispatch }, data){
      try{
        const response = await ApiService.postRequest(data.url, data.formData);
        commit('setEtudiantAbsence', response.data);
        if(response.data.raison === 17){
          let pointage = await dispatch('fetchPointagesByAbsenceId', response.data["@id"]);
          let dataPointage = {
            dt_start: response.data.dt_start,
            dt_end: response.data.dt_end,
            hr_start: response.data.hr_start,
            hr_end: response.data.hr_end,
            raison: response.data.raison,
            etudiant: response.data.etudiant,
            absence_id: response.data.id,
            pointage_id: pointage[0].id,
            emargement: response.data.emargement,
            typepointage: "absence"
            }
          dispatch('updatePointageAbsence', dataPointage);
        }
        Notify.create({
          message: "L'absence à été modifiée avec succès",
          color: 'green'
        })
      }catch(error){
        console.error(error);
        Notify.create({
          messsage: "Un erreur s'est produite lors de la modification de l'absence",
          color: 'red'
        })
      }
    },
    async deleteRetardAbsence({ dispatch }, absenceId) {
      try {
        // 1. Récupère le pointage lié à cette absence avant suppression
        const pointages = await dispatch(
          'fetchPointagesByAbsenceId',
          `/etudiant_absences/${absenceId}`
        );

        // 2. Supprime le pointage d'absence si trouvé
        if (pointages && pointages.length > 0) {
          await dispatch('deleteEtudiantPointage', pointages[0].id);
        }

        // 3. Supprime l'absence
        await ApiService.deleteRequest(`etudiant_absences/${absenceId}`);

        Notify.create({
          message: "Le retard a été supprimé avec succès",
          color: 'green'
        });
      }
      catch (error) {
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de la suppression du retard",
          color: 'red'
        });
      }
    }
  },
  getters: {
    getEtudiantAbsences(state) {
      return state.etudiantAbsences;
    },
    getEtudiantAbsence(state) {
      return state.etudiantAbsence;
    }
  }
}
